


































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Mobile } from "@/mixins/mobile";

@Component
export default class AccordionSection extends Mixins(Mobile) {
  @Prop({ default: false }) readonly open!: boolean;
  protected isOpen = false;

  created() {
    this.isOpen = this.open;
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
